var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-html-attributes"},[_c('oxygen-control',{attrs:{"control":_vm.control,"value":_vm.value},on:{"input":_vm.setValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }